// extracted by mini-css-extract-plugin
export default {"iconProduct":"IconProducts_iconProduct__jhBol"};